import API from '../api/apiUtils/api2';
import { ExtHubRequest } from '../authConfig';

const api = new API({
  url: `${process.env.REACT_APP_EXTHUB_DOMAIN}/api/FastIllustration`,
  scopes: ExtHubRequest,
});

api.createEntities([
  { name: 'Clients' },
  { name: 'RunIllustration' },
  { name: 'GetIllustrationProducts' },
  { name: 'Suffix' },
  { name: 'States' },
  { name: 'Products' },
  { name: 'Versions' },
  { name: 'ProductOptions' },
  { name: 'Riders' },
  { name: 'SingleClient' },
]);

const CreateClient = (body) => api.endpoints.Clients.post(body);
const CreateClientPdf = (body) => api.endpoints.RunIllustration.post(body);
const CreateProposalInfo = (body) => {
  return api.createBasicCRUDEndpoints(`Clients/${body.id}`).put({
    ...body,
    createdVersions: [
      {
        ...body?.createdVersions?.[0],
        illustrationData: JSON.stringify(body?.createdVersions?.[0]?.illustrationData),
      },
    ],
  });
};
const updateClient = (body) => api.endpoints.Clients.put(body);
const GetClients = () => api.endpoints.Clients.get();
const GetProducts = () => api.endpoints.Products.get();
const GetVersions = (params) => api.createBasicCRUDEndpoints(`Versions?${params}`).get();
const GetPlanType = (params) => api.createBasicCRUDEndpoints(`ProductOptions/${params}`).get();
const DeleteClient = (clientID) => {
  return api.createBasicCRUDEndpoints(`Clients/${clientID}`).delete();
};
const GetRiders = (params) => api.createBasicCRUDEndpoints(`Riders/${params}`).get();
const GetSingleClient = (params) => api.createBasicCRUDEndpoints(`Clients/${params}`).get();
const GetClient = () => api.endpoints.Clients.get();
const GetIllustrationProducts = () => api.endpoints.GetIllustrationProducts.get();
const GetSuffixDropDown = () => api.endpoints.Suffix.post();
const GetStateList = () => api.endpoints.States.post();

export {
  CreateClient,
  GetClient,
  GetClients,
  updateClient,
  GetIllustrationProducts,
  GetSuffixDropDown,
  GetStateList,
  CreateProposalInfo,
  GetProducts,
  GetVersions,
  GetPlanType,
  GetRiders,
  GetSingleClient,
  DeleteClient,
  CreateClientPdf,
};
